import React from 'react';

function Atendimento() {
  return (
    <div className="m-5 projetos-container">
      <h2>Atendimentos Psicoterapêuticos no Instituto Pasqualin</h2>
      <br></br>
      <p className="fw-bold">Cuidado Integral para Indivíduos, Casais e Famílias</p>
      <span>No Instituto Pasqualin, acreditamos que cada pessoa, relacionamento e núcleo familiar possui uma história única,
        que merece ser acolhida e compreendida com sensibilidade e respeito. Oferecemos atendimentos psicológicos especializados para indivíduos,
        casais e famílias, visando promover saúde mental, fortalecer vínculos e transformar dinâmicas que dificultam o bem-estar coletivo e
        individual.</span>

      <br></br>
      <hr></hr>
      <br></br>
      <p className="fw-bold">Nossos Diferenciais</p>

      <ol>
        <li><strong>Abordagem Humanista e Sistêmica:</strong> Trabalhamos com metodologias que reconhecem as interações entre o indivíduo, suas relações e os contextos sociais, culturais e históricos em que está inserido.</li>
        <li><strong>Respeito à Diversidade:</strong> Garantimos um espaço seguro e acolhedor para pessoas de todas as orientações sexuais, identidades de gênero, crenças, etnias e histórias de vida.</li>
        <li><strong>Atenção Personalizada:</strong> As intervenções são pensadas de maneira singular, respeitando as necessidades e os objetivos de cada cliente.</li>
        <li><strong>Ética e Confidencialidade:</strong> Seguimos rigorosamente os princípios éticos da Psicologia, assegurando um atendimento profissional e sigiloso.</li>
      </ol>


      <br></br>
      <hr></hr>
      <br></br>
      <p className="fw-bold">Tipos de Atendimento</p>
      <ul>
        <li><strong>Individual</strong>
          <ul>
            <li><strong>Para quem:</strong> Indivíduos que enfrentam desafios emocionais, comportamentais ou relacionais.</li>
            <li><strong>Objetivos:</strong>
              <ul>
                <li> Promoção do autoconhecimento e fortalecimento emocional.</li>
                <li> Apoio em momentos de crise, como luto, separações ou mudanças.</li>
                <li> Tratamento de ansiedade, depressão, estresse e outros transtornos psicológicos.</li>
                <li> Desenvolvimento de habilidades sociais e emocionais.</li>
              </ul>
            </li>
          </ul>
        </li>

        <li><strong>Casal</strong>
          <ul>
            <li><strong>Para quem:</strong> Casais em qualquer fase do relacionamento, que desejam melhorar a comunicação, resolver conflitos ou superar crises.</li>
            <li><strong>Objetivos:</strong>
              <ul>
                <li> Identificação e ressignificação de padrões disfuncionais na relação.</li>
                <li> Fortalecimento do diálogo e da empatia entre os parceiros.</li>
                <li> Apoio em situações como infidelidade, transições de vida (casamento, chegada de filhos, aposentadoria) ou decisões importantes.</li>
              </ul>
            </li>
          </ul>
        </li>

        <li><strong>Família</strong>
          <ul>
            <li><strong>Para quem:</strong> Famílias que enfrentam desafios na convivência ou na adaptação a mudanças significativas.</li>
            <li><strong>Objetivos:</strong>
              <ul>
                <li> Compreender e melhorar as dinâmicas familiares.</li>
                <li> Facilitar a comunicação e a resolução de conflitos entre membros da família.</li>
                <li> Apoiar em momentos de transição, como separações, adoção, doenças ou perda de um ente querido.</li>
                <li> Promover o fortalecimento dos laços familiares e a construção de um ambiente emocionalmente saudável.</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>

      <br></br>
      <hr></hr>
      <br></br>
      <p className="fw-bold">Como Funciona?</p>
      <ol>
        <li><strong>Primeira Consulta:</strong> Realizamos uma avaliação inicial para compreender as demandas e definir os objetivos do atendimento.</li>
        <li><strong>Planejamento Personalizado:</strong> Juntos, construímos um plano terapêutico alinhado às necessidades do cliente, casal ou família.</li>
        <li><strong>Processo Terapêutico:</strong> Por meio de encontros regulares, trabalhamos as questões trazidas, sempre respeitando o ritmo e as escolhas dos envolvidos.</li>
      </ol>


      <br></br>
      <hr></hr>
      <br></br>
      <p className="fw-bold">Compromisso com a Inclusão e a Equidade</p>
      <span>Reconhecemos que muitos dos desafios enfrentados por indivíduos, casais e famílias são atravessados por questões de gênero,
        sexualidade, raça e classe social. Por isso, nossa prática é pautada em uma escuta atenta e sensível às diversas experiências e
        histórias de vida, garantindo que todos se sintam acolhidos e valorizados.</span>

      <br></br>
      <hr></hr>
      <br></br>
      <p className="fw-bold">Agende uma Consulta</p>
      <span>Se você está em busca de apoio para lidar com desafios pessoais, fortalecer seu relacionamento ou transformar as dinâmicas 
        familiares, estamos aqui para ajudar. Entre em contato e marque uma consulta com nossos profissionais especializados.</span>
      <p className="fw-bold mt-1">Transforme sua vida, suas relações e sua história com o cuidado que você merece.</p>
    </div>
  );
}

export default Atendimento;
